import { render, staticRenderFns } from "./person-report.vue?vue&type=template&id=3b5a16ac&scoped=true&"
import script from "./person-report.vue?vue&type=script&lang=js&"
export * from "./person-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a16ac",
  null
  
)

export default component.exports